import React from "react";
import { InBodyAds } from "@bloomberg/media-ui-ads";

import styles from "./styles.module.css";

type StoryInBodyAdProps = {
    positionIncrement?: number;
};

const adOptions = {
    dimensions: {
        all: [
            [300, 250],
            [5, 24],
        ],
        large_desktop: [
            [5, 4],
            [5, 25],
            [5, 16],
        ],
        small_desktop: [
            [5, 4],
            [5, 25],
            [5, 16],
        ],
        tablet: [
            [5, 25],
            [5, 16],
        ],
        mobile: [
            [3, 4],
            [3, 3],
        ],
    },
};

export default function StoryInBodyAd({
    positionIncrement,
}: StoryInBodyAdProps) {
    return (
        <InBodyAds
            className={styles.inBodyAd}
            positionIncrement={positionIncrement}
            adOptions={adOptions}
        />
    );
}
